module.exports = __webpack_public_path__ + "img/user-dashboard-illustration.234ab10d.png";